import {
  IHttpGet,
  IHttpGetParams,
  IHttpResponse,
} from '../../../adapters/http';

import axios from 'axios';

export class AxiosHttpGetAdapter<T> implements IHttpGet<T> {
  async get<P = T>({ url, params }: IHttpGetParams): Promise<IHttpResponse<P>> {
    try {
      const { data, status } = await axios.get(`${url}`, { params });

      return {
        statusCode: status,
        body: data,
      };
    } catch (error) {
      return {
        statusCode: error.response?.status || 500,
        body: error.response?.data,
      };
    }
  }
}
